<template>
    <div class="mx-auto col-sm-12">
              <!-- Category 1 -->
        <div class="card-footer text-muted d-flex justify-content-between pb-0 pt-3">
        <div class="container p-0">
            <div class="category-cards">
            <div class="row">
                <div class="col-md-12 mb-1">
                <!-- dynamic serach results -->
                <div class="row pb-2 dyna-searchresults">
                    <div class="col-md-12 pt-0">
                    <template v-if="searchResults.length">
                        <!-- <div v-for="results in searchResultsData.slice(startIdx, endIdx)"> -->
                        <div v-for="results in searchResults.slice(startIdx, endIdx)">
                        <!-- <div v-for="(results, index) in searchResults.slice(startIdx, endIdx)" :key="index"> -->
                            <router-link :to="routeTo(results.document_id)" class="card-link d-block">
                                <div class="d-flex flex-column no-card-shadow">
                                    <div class="card-body p-0">
                                        <div class="d-flex">
                                            <Skeleton v-if="isTranslationsLoading" height="1.5rem" class="mb-1" borderRadius="10px"></Skeleton>
                                            <router-link class="search-article-title" :to="routeTo(results.document_id)" v-else>
                                                <h3 class="card-title mb-0 text-primary">
                                                {{ results.title.length > 80 ?
                                                    isTranslationLoaded(results.title).slice(0, 80).split(' ').slice(0,
                                                    -1).join(' ') + '...' : isTranslationLoaded(results.title) }}
                                                </h3>
                                            </router-link>
                                            <template v-if="results.article_category_title">
                                                <Skeleton v-if="isTranslationsLoading" height="1.5rem" class="mb-1" borderRadius="10px"></Skeleton>
                                                <router-link class="pt-0 pb-0" :to="routeToCategoryDetails(results.article_category)">
                                                    <span class="card-title mb-0 text-sm rounded flex resultcat">
                                                    {{ isTranslationLoaded(results.article_category_title) }}
                                                    </span>
                                                </router-link>
                                            </template>
                                        </div>
                                        <Skeleton v-if="isTranslationsLoading" height="2rem" class="mb-1" borderRadius="10px"></Skeleton>
                                        <p class="card-text" v-else v-html="getSearchSubstr(isTranslationLoaded(results.description))"></p>
                                        <!-- dynamic search ends here -->
                                    </div>
                                </div>
                            </router-link>
                        </div>
                        <!-- </div> -->
                        <div class="d-flex mt-5">
                            <div class="prevlink me-2" v-if="pageNumber !== 1">
                                <button type="button" :class="pageNumber === 1 ? 'btn btn-xs btn-light mb-0  disabled' : 'btn btn-xs btn-light mb-0 '"
                                @click="prevPageSearch">
                                    <i class="fa fa-chevron-left"></i>
                                </button>
                            </div>
                        <div class="nextlink" v-if="searchResults.length > pageLimit && pageNumber !== Math.ceil(searchResults.length) / pageLimit && searchResults.slice(startIdx, endIdx).length >= pageLimit">
                            <button type="button" href="javascript:void(0);"
                            :class="searchResults.length < pageLimit || pageNumber === Math.ceil(searchResults.length) / pageLimit || isNaN(Math.ceil(searchResults.length / pageLimit)) ? 'btn btn-xs btn-light mb-0  disabled' : 'btn btn-xs btn-light mb-0 '"
                            @click="nextPageSearch">
                            <i class="fa fa-chevron-right"></i>
                            </button>
                        </div>
                        <div class="d-flex align-items-center justify-content-center text-sm"
                            v-if="searchResults.length > pageLimit" style="margin-left: 10px">
                            Page {{ pageNumber }} of {{ Math.ceil(searchResults.length / pageLimit) }}
                        </div>
                        </div>
                    </template>
                    <template v-else>
                        <div>No result found</div>
                    </template>
                    </div>
                </div>
                <!---ends here -->
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
 </template>
 
 <script>
 export default {
   name: 'SearchResultWrapper',
   props: [
     'searchResults',
     'isTranslationsLoading',
     'isTranslationLoaded',
     'getSearchSubstr',
     'startIdx',
     'endIdx',
     'pageNumber',
     'pageLimit',
     'prevPageSearch',
     'nextPageSearch',
     'routeToCategoryDetails',
     'successArticleSearchId',
     'library_key',
     'isCustomSubDomain'
 ],
 methods: {
     routeTo(resultId) {
       let url = '';
       if (this.isCustomSubDomain) {
         url = '/article/details/' + resultId;
       } else {
         url = '/article/details/' + this.library_key + '/' + resultId;
       }
       if(this.successArticleSearchId) {
         url += '?successArticleSearchId=' + this.successArticleSearchId
       }
       return url;
     },
 }
 }
 </script>